// "Sell as-is" (kitchen flow, Step 4): a stock item sold one for one — a can
// of drink — becomes a menu product whose recipe is ONE component, qty 1 in
// the item's own unit. The same recipe drives the till's sale deduction and
// the kitchen plan's demand sheet. Tested in sellAsIs.test.ts.

export const SA = {
  title: 'Sell as-is',
  help: 'Drinks and anything else sold exactly as bought: each sale takes one off the kitchen’s stock, and an event plan asks the store for them.',
  open: 'Add items sold as-is',
  search: 'Search stock items…',
  name: 'Menu name',
  price: 'Menu price',
  category: 'Menu category',
  create: 'Create menu item',
  creating: 'Creating…',
  created: (n: string) => `${n} is on the menu, linked 1 : 1 to its stock item`,
  none: 'No items match.',
  recipe: (unit: string) => `Recipe: 1 ${unit}`,
} as const

/** "Pepsi Tin 250ML" → "Pepsi 250ML": drop the container word only. */
export function menuNameFor(stockName: string): string {
  return stockName.replace(/\b(slim|tin|can|drink|btl|bottle)\b/gi, ' ').replace(/\s+/g, ' ').trim() || stockName
}

export function sellAsIsPayload(d: { stockItemId: string; unit: string; name: string; price: number; categoryId?: string }) {
  return {
    name: d.name.trim(),
    price: Math.round(d.price * 100) / 100,
    ...(d.categoryId ? { category_id: d.categoryId } : {}),
    components: [{ stock_item_id: d.stockItemId, deduct_qty: 1, deduct_qty_entered: 1, deduct_unit: d.unit }],
  }
}

export const canSellAsIs = (d: { name: string; price: number }) => d.name.trim().length > 0 && d.price > 0
